import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrganisationState } from './organisation.reducer';

export const selectOrganisationState = createFeatureSelector<OrganisationState>('organisation');

export const selectOrganisationId = createSelector(
  selectOrganisationState,
  (state: OrganisationState) => state.organisation_id
);

export const selectCurrentFlow = createSelector(
  selectOrganisationState,
  (state) => state.uiContext.currentFlow
);

export const isOverviewPopupFlow = createSelector(
  selectOrganisationState,
  (state) => state.uiContext.currentFlow === 'overview-popup'
);

export const isStandaloneFlow = createSelector(
  selectOrganisationState,
  (state) => state.uiContext.currentFlow === 'standalone'
);